class NfeXlsxFields {
    constructor(gql, $scope, downloadService) {
        this.gql = gql
        this.apply = (fun) => $scope.$apply(fun)
        this.downloadService = downloadService

        this.fields = []
        this.selected = []
        this.reportType = "nfe"
    }

    $onInit() {
        this.listFields()
    }

    onSelectAll() {
        if (this.isAllSelected) {
            this.selected = this.fields.map(field => field.name)
        } else {
            this.selected = []
        }
    }

    listFields() {
        this.isAllSelected = false

        const query = gql`
            query NfeReportFields {
                reportFields {
                    fields: ${this.reportType}Xlsx {
                        name
                        description
                        optional
                    }
                }
            }
        `

        this.promise = this.gql
            .query(query, {})
            .then(({ reportFields: { fields } }) => this.fields = fields)
            .then(() => {
                const selected = localStorage.getItem(this.reportType + "XlsxColumns")

                if (selected) {
                    this.selected = JSON.parse(selected)
                } else {
                    this.selected = this.fields.filter(field => !field.optional).map(field => field.name)
                }
            })
            .catch(console.error)
    }

    gerar() {
        const field = this.reportType == 'nfe' ? 'nfesXlsx' : 'nfesItensXlsx'
        const limit = this.reportType == 'nfe' ? null : 5000

        const query = gql`
            query DownloadNfesXlsx($empresaId: Int!, $filter: NfeFilter!, $order: NfeOrder, $fields: [String], $next: String, $limit: Int) {
                contrato: empresa(id: $empresaId) {
                    id
                    operation: ${field}(order: $order, filter: $filter, fields: $fields, next: $next, limit: $limit) {
                        token
                        next
                    }
                }
            }
        `

        let { nfes, filter: { order, ...filter }, contratoId } = this.resolve
        filter = nfes.length > 0 ? { ids: nfes } : filter

        this.downloadPromise = this.paginatedDownloadOperation(query, { fields: this.selected, empresaId: contratoId, filter, order, limit })
            .then(() => localStorage.setItem(this.reportType + "XlsxColumns", JSON.stringify(this.selected)))
            .catch(console.error)
    }

    paginatedDownloadOperation(query, variables, nextPage = null, yesForAll = false) {
        return this.gql
            .query(query, { next: nextPage, ...variables })
            .then(({ contrato: { operation } }) => operation)
            .then(({ token, next }) => {
                return this.downloadService
                    .download(`/resume-operation/${token}`)
                    .then(() => {
                        if (next) {
                            if (yesForAll)
                                return this.paginatedDownloadOperation(query, variables, next, true)
                            else {
                                let options = {
                                    "Não": angular.noop,
                                    "Sim": () => this.paginatedDownloadOperation(query, variables, next)
                                }

                                const { filter } = variables

                                if ((filter.emissaoInicial && filter.emissaoFinal) || filter.emitente || filter.destinatario) {
                                    options = {
                                        ...options,
                                        "Sim para todos": () => this.paginatedDownloadOperation(query, variables, next, true)
                                    }
                                }

                                return Confirm.info(
                                    "Download parcial",
                                    "Devido ao limite da operação solicitada, " +
                                    "não foi possível incluir todos os resultados. " +
                                    "Deseja realizar o download do próximo lote?",
                                    options
                                )
                            }
                        }
                    })
            })
    }
}

angular.module('eficienciaFiscalModule')
    .component('nfeXlsxFields', {
        controller: ['gql', '$scope', 'downloadService', NfeXlsxFields],
        bindings: {
            close: '&',
            dismiss: '&',
            resolve: '<'
        },
        template: `
            <div class="modal-header">
                <h3 class="modal-title">
                    Campos da planilha
                </h3>
            </div>
            <div class="modal-body">
                <div class="clearfix">
                    <highlighted>
                        <main>Campos da planilha</main>
                        <secondary>Selecione os campos abaixo que irão compor a planilha</secondary>
                    </highlighted>
                    <div class="row">
                        <div class="col-xs-12">
                        <loading promise="$ctrl.promise">
                            <div class="col-xs-12">
                                <div class="smart-form">
                                    <label class="radio no-break">
                                        <input type="radio" ng-model="$ctrl.reportType" ng-change="$ctrl.listFields()" value="nfe">
                                        <i></i> Exportar dados da NF-e
                                    </label>
                                    <label class="radio no-break">
                                        <input type="radio" ng-model="$ctrl.reportType" ng-change="$ctrl.listFields()" value="nfeItens">
                                        <i></i> Exportar dados dos itens (limitado a 5000 NF-e por planilha)
                                    </label>
                                </div>
                            </div>
                            <div class="col-xs-12" style="border: 1px #f7eaea solid; border-radius: 3px; padding-top: 10px; padding-bottom: 10px; margin-top: 15px; margin-bottom: 10px;">
                                <div class="smart-form">
                                    <label class="checkbox">
                                        <input type="checkbox" ng-model="$ctrl.isAllSelected" ng-change="$ctrl.onSelectAll()" />
                                        <i></i>
                                        <span ng-class="{'text-bold': $ctrl.isAllSelected}">Selecionar todos</span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-4" ng-repeat="field in $ctrl.fields">
                                <div class="smart-form">
                                    <label class="checkbox">
                                        <input type="checkbox" checklist-model="$ctrl.selected" checklist-value="field.name" />
                                        <i></i>
                                        <span ng-class="{'text-bold': $ctrl.selected.includes(field.name)}">{{field.description}}</span>
                                    </label>
                                </div>
                            </div>
                        </loading>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <promise-tracker promise="$ctrl.downloadPromise" active="isLoading">
                    <button class="btn btn-primary" disabled ng-show="isLoading">
                        <i class="fa fa-circle-o-notch fa-spin"></i> Gerando...
                    </button>
                    <button class="btn btn-primary" ng-click="$ctrl.gerar()" ng-hide="isLoading">Gerar XLSX</button>
                    <button class="btn btn-default" ng-click="$ctrl.close()" ng-disabled="isLoading">Fechar</button>
                </promise-tracker>
            </div>
        `
    })
